export default "__VITE_ASSET__99bb9f59__"